module.exports = __webpack_public_path__ + "img/win_paytable.5df50187.png";